import Constants from '@/Constants';
import { GetClassificationsData } from '@/models/GetClassificationsData';
import http from '@/services/HttpService';
import { call, put } from 'redux-saga/effects';
import { PayloadAction } from 'typesafe-actions';
import { getClassificationsFailure, getClassificationsSuccess } from './action';
import { ClassificationsTypes } from './types';

export function* getClassificationsRequest(action: PayloadAction<ClassificationsTypes.GET_CLASSIFICATIONS_REQUEST, GetClassificationsData>) {
    try {
        const { applicationId, organizationId } = action.payload;
        const path = Constants.SOCIAL_CLASSIFICATIONS_URI;
        const queryParams: string = `?applicationId=${applicationId}&organizationId=${organizationId}`;
        const response = yield call(http.get, path + queryParams);
        yield put(getClassificationsSuccess(response.data));
    } catch (error) {
        yield put(getClassificationsFailure());
    }
}
